// French strings of the task drawer and the approvals queue (registered at module load; the shell
// dictionary already holds the shared vocabulary: state.*, approval.*, taskdrawer.*, task.*).
import { registerStrings } from '../../i18n/fr.js';

registerStrings({
  // Task drawer: frame and errors
  'td.eyebrow': 'TÂCHE',
  'td.loading': 'Chargement de la tâche…',
  'td.notFound.title': 'Tâche introuvable',
  'td.notFound.text': 'Elle a peut-être été supprimée, ou elle ne fait pas partie de vos accès.',
  'td.forbidden.title': 'Accès refusé',
  'td.forbidden.text': 'Vous n’avez pas accès à cette tâche.',
  'td.error.title': 'Impossible de charger la tâche',
  'td.removed.title': 'Tâche supprimée',
  'td.removed.text': 'Cette tâche vient d’être supprimée.',
  'td.partial': 'Le détail complet de cette tâche n’est pas encore disponible sur ce serveur : seules les informations principales sont affichées.',

  // Header
  'td.agentOpen': 'Ouvrir la fiche de {name}',
  'td.agentRouting': 'Choix de l’agent…',
  'td.deptFloor': '{dept} · {floor}',
  'td.autonomy.approve': 'JE VALIDE AVANT D’AGIR',
  'td.autonomy.auto': 'AGIT SEUL',
  'td.src.you': 'Demandée par vous',
  'td.src.someone': 'Demandée par un membre de l’équipe',
  'td.src.chatYou': 'Depuis votre discussion avec l’agent',
  'td.src.chatBy': 'Depuis une discussion de {name}',
  'td.src.calendarYou': 'Depuis le calendrier (vous)',
  'td.src.calendarBy': 'Depuis le calendrier ({name})',
  'td.src.unnamedRoutine': 'sans nom',
  'td.src.unnamedTrigger': 'sans nom',
  'td.src.external': 'Référence externe : {ref}',
  'td.src.delegation': 'Demandée par {name}',
  'td.src.watch': 'Lancée par le contrôle de production du Studio',
  'td.src.colleague': 'un collègue',
  'td.src.parentLink': 'Ouvrir la tâche mère',
  'td.children.intro': 'Travail confié par cette tâche à des collègues de l’étage.',
  'td.children.open': 'Ouvrir la tâche « {title} »',

  // Status block
  'td.status.scheduled': 'Prévue {when}',
  'td.status.scheduledHint': 'Elle partira toute seule à l’heure dite.',
  'td.status.queued': 'En attente de son tour',
  'td.status.queuedHint': 'Dans la file depuis {duration}. Un agent ne fait qu’une tâche à la fois.',
  'td.status.running': 'L’agent travaille',
  'td.status.executing': 'L’agent exécute la version approuvée',
  'td.status.elapsed': 'depuis {duration}',
  'td.status.activity': 'En ce moment : {activity}',
  'td.status.waitingOther': 'En attente de validation',
  'td.status.waitingOtherHint': 'Un responsable du service doit relire le brouillon avant qu’il parte.',
  'td.status.failed': 'La tâche a échoué',
  'td.status.failedHint': 'Vous pouvez la relancer telle quelle.',
  'td.status.blocked': 'Bloquée : une cause extérieure a arrêté l’agent',
  'td.status.blockedHint': 'Cause non précisée : voir le résultat.',
  'td.status.todo': 'À régler : l’agent attend une décision ou une action',
  'td.status.todoSettled': 'À régler (marqué comme réglé)',
  'td.status.todoHint': 'Voir le résultat.',
  'td.status.rejected': 'Brouillon refusé',
  'td.status.ignored': 'Ignorée',
  'td.status.ignoredBy': 'Ignorée par {name}',
  'td.status.ignoredHint': 'Elle ne compte plus comme une erreur, ne figure plus dans « À régler » et sa routine ne la relance plus. « Ne plus ignorer » la remet en place.',
  'td.status.ignoredDraftHint': 'Le brouillon est mis de côté. « Ne plus ignorer » le remet à valider.',
  'td.status.superseded': 'Échec résolu ensuite',
  'td.status.supersededHint': 'Un passage suivant de sa routine a réussi : ce n’est plus une erreur.',
  'td.status.supersededIdleHint': 'Un passage suivant de sa routine a vérifié qu’il n’y avait rien à faire : ce n’est plus une erreur.',
  'td.status.cancelled': 'Tâche annulée',
  'td.status.late': 'Partie avec du retard (le Mac mini était peut-être éteint).',

  // Approval box
  'td.approval.title': 'À VALIDER',
  'td.approval.hint': 'Rien n’est parti. Relisez le brouillon, modifiez-le si besoin, puis approuvez ou refusez.',
  'td.approval.actions': 'Décision sur le brouillon',
  'td.approval.noDraft': 'L’agent n’a pas laissé de brouillon.',
  'td.approval.approving': 'Validation…',
  'td.approval.edited': 'MODIFIÉ',
  'td.approval.revert': 'Rétablir l’original',
  'td.approval.preview': 'Aperçu',
  'td.approval.edit': 'Modifier',
  'td.approval.editLabel': 'Brouillon modifiable',
  'td.approval.jsonInvalid': 'Le brouillon doit rester un JSON valide : n8n le relit tel quel.',
  'td.approval.escHint': 'Échap quitte la modification sans fermer.',

  // Reject form
  'td.reject.title': 'Refuser le brouillon',
  'td.reject.placeholder': 'Ex. : trop long, le ton est trop formel, il manque le numéro de commande…',
  'td.reject.hint': 'Soyez précis : l’agent refait le travail avec ce retour.',
  'td.reject.rememberHint': 'Ajouté à ses règles apprises (300 caractères au plus).',
  'td.reject.rerunLabel': 'Refaire avec ce retour',
  'td.reject.rerunHint': 'Sinon, la tâche est refusée définitivement.',
  'td.reject.submitRerun': 'REFUSER ET REFAIRE',
  'td.reject.submitFinal': 'REFUSER',
  'td.reject.required': 'Dites ce qui ne va pas : l’agent en a besoin pour refaire ou pour retenir la règle.',
  'td.reject.tooLong': 'Retour trop long ({max} caractères au plus).',
  'td.reject.lessonCut': 'Seuls les 300 premiers caractères seront retenus comme règle.',
  'td.reject.rerunDone': 'Refusée : l’agent refait le travail avec votre retour.',
  'td.reject.finalDone': 'Brouillon refusé.',

  // Sections
  'td.section.request': 'DEMANDE',
  'td.section.result': 'RÉSULTAT',
  'td.section.draft': 'BROUILLON',
  'td.section.output': 'SORTIE JSON',
  'td.section.files': 'FICHIERS',
  'td.section.inputFiles': 'FICHIERS FOURNIS',
  'td.section.details': 'DÉTAILS',
  'td.section.timeline': 'CHRONOLOGIE',
  'td.section.decisions': 'DÉCISIONS',
  'td.section.decide': 'À DÉCIDER',
  'td.section.decided': 'DÉCISION PRISE',
  'td.decide.intro': 'Cochez ce que {agent} doit faire : il s’en charge dans une nouvelle tâche, et celle-ci est marquée réglée.',
  'td.decide.introFree': 'Dites à {agent} ce qu’il doit faire, ou « Tout faire » pour ce qu’il propose : il s’en charge dans une nouvelle tâche, et celle-ci est marquée réglée.',
  'td.decide.placeholder': 'Consigne (facultatif) : ex. « garde la mise en page », « pour le 2, mets plutôt… »',
  'td.decide.placeholderFree': 'Ex. : fais toutes les corrections sauf celle des CGV ; l’accès est donné, recommence.',
  'td.decide.comment': 'Consigne pour {agent}',
  'td.decide.selected': 'FAIRE CE QUI EST COCHÉ',
  'td.decide.send': 'ENVOYER LA CONSIGNE',
  'td.decide.all': 'TOUT FAIRE',
  'td.decide.empty': 'Cochez au moins un point, écrivez une consigne ou choisissez « Tout faire ».',
  'td.decide.done': 'Confié à {agent} : la suite est dans une nouvelle tâche.',
  'td.decided.by': 'Décision de {name}, {when}.',
  'td.decided.all': 'Tout faire.',
  'td.decided.followUp': 'Voir la tâche de suite',
  'td.followUpOf': 'Suite de la tâche « {title} »',
  'td.section.callback': 'RETOUR À N8N',
  'td.section.tools': 'OUTILS UTILISÉS',
  'td.section.usage': 'CONSOMMATION',
  'td.section.children': 'TÂCHES CONFIÉES',
  'td.section.attempts': 'ESSAIS',
  'td.attempts.intro': 'Chaque exécution de la tâche, de la première à la dernière : une routine relance la même tâche à son passage suivant tant qu’elle échoue.',
  'td.attempt.n': 'Essai {n}',
  'td.attempt.failed': 'échec',
  'td.attempt.blocked': 'bloquée',
  'td.attempt.idle': 'réussi (rien à faire)',
  'td.attempt.done': 'réussi',
  'td.attempt.cancelled': 'arrêté',
  'td.attempt.current': 'Essai {n} : en cours',
  'td.showMore': 'Afficher tout',
  'td.showLess': 'Réduire',
  'td.copyJson': 'Copier le JSON',
  'td.copyFailed': 'Copie impossible : sélectionnez le texte à la main.',
  'td.noResult': 'Aucun texte rendu.',

  // Details
  'td.time.created': 'Créée',
  'td.time.started': 'Démarrée',
  'td.time.finished': 'Terminée',
  'td.time.due': 'Prévue',
  'td.time.waiting': 'En attente depuis',
  'td.time.duration': 'Durée du travail',
  'td.engine': 'Moteur',
  'td.engineLine': '{engine}{model}{effort}',
  'td.autonomy': 'Autonomie',
  'td.autonomyApprove': 'Je valide avant d’agir',
  'td.autonomyAuto': 'Agit seul',
  'td.revisions': 'Révisions',
  'td.format': 'Format',
  'td.format.json': 'JSON',
  'td.format.text': 'Texte',

  // Decisions (approvals history)
  'td.decision.approved': 'Approuvée par {name}',
  'td.decision.approvedEdited': 'Approuvée par {name}, après modification',
  'td.decision.rejected': 'Refusée par {name}',
  'td.decision.someone': 'un membre',

  // Callback
  'td.callback.pending': 'EN ATTENTE',
  'td.callback.sent': 'ENVOYÉ',
  'td.callback.failed': 'ÉCHEC',
  'td.callback.pendingText': 'Le résultat sera renvoyé à n8n.',
  'td.callback.retryText': { one: '{n} tentative, prochaine {when}.', other: '{n} tentatives, prochaine {when}.' },
  'td.callback.sentText': 'Renvoyé à n8n {when}.',
  'td.callback.failedText': { one: 'Abandon après {n} tentative.', other: 'Abandon après {n} tentatives.' },
  'td.callback.lastError': 'Dernière erreur : {error}',

  // Tools
  'td.tool.webSearch': 'Recherche web',
  'td.tool.webFetch': 'Lecture de pages web',
  'td.tool.files': 'Fichiers',
  'td.tool.image': 'Création d’image',
  'td.tool.shell': 'Commandes',
  'td.tool.library': 'Connecteur retiré de la bibliothèque',
  'td.tool.count': { one: '{n} outil', other: '{n} outils' },

  // Usage
  'td.usage.input': 'Jetons en entrée',
  'td.usage.output': 'Jetons en sortie',
  'td.usage.cacheRead': 'Cache relu',
  'td.usage.cacheWrite': 'Cache écrit',
  'td.usage.cost': 'Coût estimé',
  'td.usage.note': 'Visible par l’administrateur seulement.',

  // Timeline
  'td.timeline.tools': { one: '{n} appel d’outil', other: '{n} appels d’outils' },
  'td.timeline.empty': 'Pas encore d’étape enregistrée.',

  // Files
  'td.files.open': 'Agrandir {name}',
  'td.files.download': 'Télécharger {name}',
  'td.files.lightbox': 'Image {i} sur {n}',
  'td.files.prev': 'Image précédente',
  'td.files.next': 'Image suivante',

  // Actions
  'td.action.cancel': 'ANNULER LA TÂCHE',
  'td.action.retry': 'RELANCER',
  'td.action.ignore': 'IGNORER',
  'td.action.ignoreTitle': 'Ne plus compter cette tâche comme une erreur (elle quitte « À régler », sa routine ne la relance plus)',
  'td.action.unignore': 'NE PLUS IGNORER',
  'td.done.ignore': 'Ignorée : elle ne compte plus comme une erreur.',
  'td.done.unignore': 'N’est plus ignorée.',
  'td.action.delete': 'SUPPRIMER',
  'td.confirm.cancel.title': 'Annuler la tâche ?',
  'td.confirm.cancel.running': 'L’agent est interrompu. Ce qu’il a déjà fait à l’extérieur n’est pas défait.',
  'td.confirm.cancel.waiting': 'La tâche ne sera pas exécutée.',
  'td.confirm.cancel.ok': 'ANNULER LA TÂCHE',
  'td.confirm.cancel.keep': 'Garder la tâche',
  'td.confirm.retry.title': 'Relancer la tâche ?',
  'td.confirm.retry.text': 'La même demande repart dans la file de {agent}.',
  'td.confirm.retry.ok': 'RELANCER',
  'td.confirm.delete.title': 'Supprimer la tâche ?',
  'td.confirm.delete.text': 'La tâche, son résultat et ses fichiers sont supprimés définitivement.',
  'td.confirm.delete.ok': 'SUPPRIMER',
  'td.done.cancel': 'Tâche annulée.',
  'td.done.retry': 'Tâche relancée.',
  'td.done.delete': 'Tâche supprimée.',

  // Approvals queue
  'ap.eyebrow': 'À VALIDER',
  'ap.title': 'Validations',
  'ap.titleCount': { one: '{n} brouillon à relire', other: '{n} brouillons à relire' },
  'ap.loading': 'Chargement des brouillons…',
  'ap.counter': '{i} / {n}',
  'ap.counterAria': 'Brouillon {i} sur {n}',
  'ap.prev': 'Brouillon précédent (K)',
  'ap.next': 'Brouillon suivant (J)',
  'ap.queueLabel': 'Brouillons à valider, par étage',
  'ap.waitingSince': 'attend depuis {duration}',
  'ap.openTask': 'Ouvrir la tâche',
  'ap.keys': 'Raccourcis',
  'ap.key.approve': 'approuver',
  'ap.key.reject': 'refuser',
  'ap.key.edit': 'modifier',
  'ap.key.nav': 'suivant / précédent',
  'ap.detailLoading': 'Chargement du brouillon…',
  'ap.detailUnavailable': 'Le brouillon n’a pas pu être chargé.',
  'ap.handledElsewhere': 'Ce brouillon vient d’être traité par quelqu’un d’autre.',
  'ap.empty.title': 'Rien à valider',
  'ap.empty.text': 'Les brouillons des agents arrivent ici avant de partir. Profitez du calme.',
  'ap.empty.done': { one: 'Vous avez traité {n} brouillon. Merci !', other: 'Vous avez traité {n} brouillons. Merci !' },
  'ap.empty.illustration': 'Un bac à courrier vide, une plante et une coche verte',
  'ap.unavailable': 'La file de validation n’est pas encore disponible sur ce serveur : les brouillons connus du navigateur sont affichés.',
  'ap.approvedNext': 'Approuvée. Brouillon suivant.',
  'ap.rejectedNext': 'Refusée. Brouillon suivant.',
  'ap.floorGroup': '{floor} · {n}',
  'ap.request': 'Demande : {text}',
  'ap.agentLine': '{agent} · {dept}',

  // Task drawer: extra sections and states
  'td.section.payload': 'DONNÉES REÇUES DE N8N',
  'td.section.status': 'OÙ EN EST-ELLE',
  'td.payloadHint': 'Le contenu envoyé par n8n, tel quel. L’agent l’a traité comme une donnée, jamais comme une consigne.',
  'td.readonlyDraft': 'Brouillon de l’agent (lecture seule).',
  'td.previousDraft': 'Dernier brouillon',
  'td.progress': 'Avancement : {p} %',
  'td.late': 'EN RETARD',
  'td.revision': { one: '{n} RÉVISION', other: '{n} RÉVISIONS' },
  'td.retryLoad': 'Réessayer',
  'td.actionsLabel': 'Actions sur la tâche',
  'td.approve.done': 'Approuvée.',
  'td.approve.executing': 'Approuvée : l’agent exécute la version validée.',
  'td.conflict': 'Cette tâche vient de changer d’état : elle a été rechargée.',
  'td.unknownAgent': 'Agent inconnu',
});
